import React, { useEffect, useState } from "react";
import {
    Button,
    Modal,
    ModalClose,
    Sheet,
    Typography,
    Input,
    FormControl,
    FormLabel,
    Table, Stack, IconButton, ModalDialog
} from "@mui/joy";
import {
    createOrganization,
    deleteOrganization,
    editOrganization,
    getExperiences,
    getOrganizations
} from "../utils/ViewModel";
import {PageStandard} from "../utils/PageStandard";
import {Organization, OrganizationInput} from "../utils/Model";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";

export function Organizations() {
    const [modalNewOrg, setModalNewOrg] = useState(false);
    const [orgs, setOrgs] = useState<Organization[]>([]);

    const fetchOrganizations = () => {
        getOrganizations().then(organizations => {
            setOrgs(organizations);
        });
    }
    useEffect(() => {
        fetchOrganizations()
    }, []);

    const handleCreateOrg = async (data: OrganizationInput) => {
        const success = await createOrganization(data);
        if (success) {
            setModalNewOrg(false);
            await fetchOrganizations(); // o aggiorni lo stato
        }
    };

    return (
        <PageStandard
            title="Organizzazioni"
            sidebarVisible={true}
            headerEnd={
                <Button onClick={() => setModalNewOrg(true)}>
                    Nuova organizzazione
                </Button>
            }
        >
            <Table aria-label="Organizzazioni" size="md">
                <thead>
                <tr>
                    <th style={{ width: "30%" }}>Nome</th>
                    <th style={{ width: "30%" }}>ID</th>
                    <th>Stripe Public Key</th>
                    <th>Stripe Secret Key</th>
                    <th>Azioni</th>
                </tr>
                </thead>
                <tbody>
                {orgs.map((org) => (
                    <OrgRowTable org={org} key={org.id} refresh={fetchOrganizations} />
                ))}
                </tbody>
            </Table>

            <ModalNewOrg
                open={modalNewOrg}
                onClose={() => setModalNewOrg(false)}
                onCreate={handleCreateOrg}
            />
        </PageStandard>
    );
}

function OrgRowTable(props: {org: Organization, refresh: () => void}) {
    const org = props.org
    const refresh = props.refresh

    const [editModalOpen, setEditModalOpen] = useState(false);
    const [formData, setFormData] = useState<Organization>(org);

    const handleDeleteClick = async (orgId: string) => {
        const confirmed = window.confirm("Sei sicuro di voler eliminare questa organizzazione?");
        if (confirmed) {
            const ok = await deleteOrganization(orgId);
            if (ok) {
                refresh()
            }
        }
    };

    const handleEditSubmit = async () => {
        const ok = await editOrganization(org.id, formData);
        if (ok) {
            setEditModalOpen(false);
            refresh()
        }
    };

    return (
        <tr key={org.id}>
            <td>{org.name}</td>
            <td>{org.id}</td>
            <td>****************</td>
            <td>****************</td>
            <td>
                <Stack direction="row" spacing={1}>
                    <IconButton
                        variant="outlined"
                        color="neutral"
                        size="sm"
                        onClick={() => setEditModalOpen(true)}
                    >
                        <EditIcon/>
                    </IconButton>
                    <IconButton
                        variant="outlined"
                        color="danger"
                        size="sm"
                        onClick={() => handleDeleteClick(org.id)}
                    >
                        <DeleteForeverIcon/>
                    </IconButton>
                </Stack>
            </td>

            <Modal
                open={editModalOpen}
                onClose={() => setEditModalOpen(false)}
                sx={{display: "flex", justifyContent: "center", alignItems: "center"}}
            >
                <Sheet
                    variant="outlined"
                    sx={{ minWidth: 500, borderRadius: "md", p: 3, boxShadow: "lg" }}
                >
                    <ModalClose variant="plain" sx={{ m: 1 }} />
                    <Typography level="title-md" fontWeight="bold" mb={2}>
                        Modifica Organizzazione
                    </Typography>

                    <FormControl size="sm" sx={{ mb: 1 }}>
                        <FormLabel>Nome organizzazione</FormLabel>
                        <Input
                            placeholder="Nome"
                            value={formData.name}
                            onChange={(e) => setFormData({...formData, name: e.target.value})}
                        />
                    </FormControl>

                    <FormControl size="sm" sx={{ mb: 1 }}>
                        <FormLabel>Stripe Public Key</FormLabel>
                        <Input
                            placeholder="****************"
                            value={formData.stripe_public_key}
                            onChange={(e) => setFormData({...formData, stripe_public_key: e.target.value})}
                        />
                    </FormControl>

                    <FormControl size="sm" sx={{ mb: 2 }}>
                        <FormLabel>Stripe Secret Key</FormLabel>
                        <Input
                            placeholder="****************"
                            value={formData.stripe_secret_key}
                            onChange={(e) => setFormData({...formData, stripe_secret_key: e.target.value})}
                        />
                    </FormControl>

                    <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{mt: 2}}>
                        <Button variant="outlined" onClick={() => setEditModalOpen(false)}>Annulla</Button>
                        <Button onClick={handleEditSubmit}>Salva</Button>
                    </Stack>
                </Sheet>
            </Modal>
        </tr>
    )
}

type ModalNewOrgProps = {
    open: boolean;
    onClose: () => void;
    onCreate: (org: OrganizationInput) => void;
};


function ModalNewOrg({open, onClose, onCreate}: ModalNewOrgProps) {
    const [name, setName] = useState("");
    const [stripePub, setStripePub] = useState("");
    const [stripeSec, setStripeSec] = useState("");

    const handleSubmit = () => {
        onCreate({
            name,
            stripe_public_key: stripePub,
            stripe_secret_key: stripeSec,
        });
    };

    useEffect(() => {
        if (!open) {
            setName("");
            setStripePub("");
            setStripeSec("");
        }
    }, [open]);

    return (
        <Modal
            open={open}
            onClose={onClose}
            sx={{display: "flex", justifyContent: "center", alignItems: "center"}}
        >
            <Sheet
                variant="outlined"
                sx={{ minWidth: 500, borderRadius: "md", p: 3, boxShadow: "lg" }}
            >
                <ModalClose variant="plain" sx={{ m: 1 }} />
                <Typography level="title-md" fontWeight="bold" mb={2}>
                    Nuova organizzazione
                </Typography>

                <FormControl size="sm" sx={{ mb: 1 }}>
                    <FormLabel>Nome organizzazione</FormLabel>
                    <Input
                        placeholder="Nome organizzazione"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </FormControl>

                <FormControl size="sm" sx={{ mb: 1 }}>
                    <FormLabel>Stripe Public Key</FormLabel>
                    <Input
                        placeholder="Stripe Public Key"
                        value={stripePub}
                        onChange={(e) => setStripePub(e.target.value)}
                    />
                </FormControl>

                <FormControl size="sm" sx={{ mb: 2 }}>
                    <FormLabel>Stripe Secret Key</FormLabel>
                    <Input
                        placeholder="Stripe Secret Key"
                        value={stripeSec}
                        onChange={(e) => setStripeSec(e.target.value)}
                    />
                </FormControl>

                <Button fullWidth onClick={handleSubmit}>
                    Crea organizzazione
                </Button>
            </Sheet>
        </Modal>
    );
}
